import type { Role } from "@/types/api";

/** Home/landing path for each role. Used by ProtectedRoute redirects + post-login navigation. */
export function roleHomePath(role: Role): string {
  switch (role) {
    case "super_admin": return "/super_admin";
    case "admin":       return "/admin";
    case "shore_staff": return "/shore_staff";
    case "vessel":      return "/dashboard";
    default:            return "/login";
  }
}
